'use es6';

import { CAMPAIGN_TYPE_ID, MARKETING_EVENT_TYPE_ID, WEB_INTERACTIVE } from 'customer-data-filters/data/objectTypeIds';
import getIn from 'transmute/getIn';
import ObjectCoordinatesReferenceResolver from 'reference-resolvers/resolvers/ObjectCoordinatesReferenceResolver';
const objectTypeIdToOptions = {
  [MARKETING_EVENT_TYPE_ID]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_event_name', 'value'])
      }
    }
  },
  [CAMPAIGN_TYPE_ID]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_name', 'value'])
      }
    }
  },
  [WEB_INTERACTIVE]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_name', 'value'])
      }
    }
  }
};
export const getResolverForObject = objectTypeId => {
  const options = objectTypeIdToOptions[objectTypeId] || {};
  return ObjectCoordinatesReferenceResolver(objectTypeId, options);
};